import React, { useState, useEffect } from 'react'
import {  Button, Dropdown, Modal ,Form } from 'react-bootstrap';
import api from "../../../../services/api";
import Funcionarios from '../../cadastros/funcionarios';
import { format, set, setDate } from 'date-fns'
import { connect } from "react-redux";

function LancarOcorrencias(props) {
  const [showModal, setShowModal] = useState(false);
  const [ocorrencias, setOcorrencias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ocorrencia, setOcorrencia] = useState('');
  const [pesquisarNome, setPesquisarNome] = useState("");
  const [funcionarios, setFuncionarios] = useState([]);
  const [estado, setEstado] = useState(false);
  const [inicioData, setInicioData] = useState('01-05-2020');
  const [fimData, setFimData] = useState();
  const [lancarBH, setLancarBH] = useState()
  const [idfuncionario, setidFuncionario] = useState();
  const [botao1, botao2] = useState();
  const [idpessoa, setIdPessoa] = useState([]);
  const [funcionariosCheckout, setFuncioariosCheckout] = useState();
  const [allChecked, setAllChecked] = useState();


  useEffect(() => {
    obterOcorrencias();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  




  async function obterFuncionarios() {
    setLoading(true);
    api
      .get("/funcionarios/nomes")
      .then((res) => {
       console.log(res.data)
        const { funcionarios } = res.data;
       
        let list = [];
        funcionarios.map((item) => {
          list.push({
            idfuncionario: item.idPessoa,
            nome: item.nome,
            isChecked: false,
          });
        })
        console.log("list", list);
        setFuncioariosCheckout(list);
        setFuncionarios(funcionarios);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }


async function redirecione(){
  window.location = '/dashboard/movimentacoes/lancarOcorrencias'
}

  function handleModal() { 
    setShowModal(true);
  }

  function handleCloseModal() {

    setShowModal(false);
  }



  async function obterOcorrencias() {
    setLoading(false);
    api
      .get("tipoOcorrencias")
      .then((res) => {
        const ocorrencias = res.data.TiposOcorrencias;

        setOcorrencias(ocorrencias);
        obterFuncionarios()
        setLoading(false);
      })
      .catch((err) => {
        // setLoading(false);
        console.error(err);
      });
  }

 

  async function handleCheckout(e) {
    let itemName = e.target.name;
    let checked = e.target.checked;
    let itemValue = e.target.value;
   // console.log({ itemName, checked, itemValue });
    if (itemName === "checkAll") {
      setAllChecked(checked);
      let list = funcionariosCheckout.map((item) => ({
        ...item,
        isChecked: checked,
      }));
      setFuncioariosCheckout(list);
    } else {
      let list = funcionariosCheckout.map((item) => {
        if (item.idfuncionario === Number(itemValue)) {
          return { ...item, isChecked: checked };
        } else {
          return item;
        }
      });
      let _allChecked = list.every((item) => item.isChecked);
      setFuncioariosCheckout(list);
      setAllChecked(_allChecked);
    }
  }


 async function handleSalvar(){
    funcionariosCheckout.map((itemx) => {
      if(itemx.isChecked === true){
     idpessoa.push(`${itemx.idfuncionario}`)
      }
    })

      
      api.post('movimentacoes/lancarOcorrencias', {idpessoa , ocorrencia, inicioData , fimData})
      .then(res => {
        console.log(res)
        handleModal()
      }).catch(err => {
        console.log(err)
      })
   
    
   
    
  }

  return (
    
    <div>



      {/*<PageHeader 
       
        hasButton={true} 
        buttonText="" 
        pageName="" 
      />*/}
     
      <div className="row">
       
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {loading ?
                <h4 className="card-title">Lançamento de Ocorrências</h4>
                : ocorrencias ?


                  <div className="row">
                    <div className="col">
                      <div className="col-md-4">
                        <Form.Group className="row">
                          <label htmlFor="exampleFormControlSelect1">Tipo de Ocorrência</label>

                          <select className="form-control form-control-lg" onChange={(e) => setOcorrencia(e.target.value)}>
                            {ocorrencias.map((item) =>
                              <option value={item.idTipoOcorrencia}>{item.TipoOcorrencia}</option>

                            )}
                          </select>
                        </Form.Group>
                      </div>
                      <div className="row">
                        <div className="row ">
                          <div className="col-md-11">
                            <Form.Group className="row">
                              <div className="col-sm-12">
                                <Form.Control type="date" onChange={(e) => setInicioData(e.target.value)} />
                              </div>
                            </Form.Group>
                          </div>



                        </div>
                        <div className="row ">
                          <div className="col-md-11">
                            <Form.Group className="row">
                              <div className="col-sm-12">
                                <Form.Control type="date" onChange={(e) => setFimData(e.target.value)} />
                              </div>
                            </Form.Group>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div className="" >
                      <div className="form-check ">
                        <label className="form-check-label text-muted">
                          <input type="checkbox" onChange={(e) => setLancarBH(!lancarBH)} className="form-check-input" />
                          <i className="input-helper"></i>
                    Lançar desconto no BH
                  </label>
                      </div>
                      <br />                                  <div style={lancarBH ? { display: 'block' } : { display: 'none' }}>
                        <Form.Group>
                          <label>Lançar minutos no BH </label>
                          <Form.Control type="time" />
                        </Form.Group>
                        <p>Conserve 00:00 para lançar o<br />
                      valor integral da coluna <br />
                      desconto no Banco de Horas</p>
                      </div>
                    </div>
                  </div>
                  : <div></div>}

            </div>

          </div>

        </div>
      </div>

      
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Funcionários</h4>
              <div className="row">
                <Form.Group>
                  <div className="input-group">
                    <Form.Control type="text"  //value={pesquisarNome}
                      onChange={(e) => setPesquisarNome(e.target.value)} className="form-control" placeholder="Pesquisa Nomes" aria-label="Pesquisa Nomes" aria-describedby="basic-addon2" />
                    <div className="input-group-append">
                      <button className="btn btn-sm btn-primary" type="button">Pesquisar</button>
                    </div>
                  </div>
                </Form.Group>
              </div>
              <div>




              </div>
              <div className="row ">
                <div className="form-check ">
                  <label className="form-check-label text-muted">
                    <input type="checkbox" name="checkAll" onChange={handleCheckout}  /*checked={}*/ className="form-check-input" />
                    <i className="input-helper"></i>
                      Selecionar Todos
                    </label>
                </div>
              </div>
              <br></br>
              {/* <p className="card-description"> Add className <code>.table-striped</code> </p>*/}
              {loading ? <div>Carregando</div> : funcionariosCheckout ?
              <div className="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Nome</th>
                      <th>Marcar</th>
                    </tr>
                  </thead>
                 
                    <tbody>
                      {funcionariosCheckout.map((itemx) => [itemx.nome].filter(test => test.includes(`${pesquisarNome.toUpperCase()}`)).map(Nome => (
                        <tr>

                          <th scope="row" >{Nome}</th>
                          <td>
                            <div className="form-check ">
                              <label className="form-check-label text-muted">

                                <input type="checkbox" id="usuario" value={itemx.idfuncionario} checked={itemx.isChecked} onChange={handleCheckout} className="form-check-input" />

                                <i className="input-helper" ></i>
                              </label>
                            </div>
                          </td>
                        </tr>
                      )))}


                    </tbody>
                  
                </table>
                <button type="submit" onClick={handleSalvar} className="btn btn-primary mr-2">Salvar</button>
              </div>
                : <div></div>}
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal}  onHide={handleCloseModal}>
          <Modal.Header>
            <Modal.Title>Atenção</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Ocorrência lançada com sucesso! 
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary"  onClick={redirecione}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
    </div>
   
  )
}

const mapStateToProps = (state) => ({
  idEmpresa: state.data.idEmpresa,
});

export default connect(mapStateToProps)(LancarOcorrencias);